import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

interface Props {
  modelValue: string | number;
  label?: string;
  placeholder?: string;
  icon?: string;
  type?: string;
  outlined?: boolean;
  dense?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  clearable?: boolean;
  error?: boolean;
  errorMessage?: string;
  helperText?: string;
  size?: 'sm' | 'md' | 'lg';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSTextField',
  props: {
    modelValue: {},
    label: { default: '' },
    placeholder: { default: '' },
    icon: { default: '' },
    type: { default: 'text' },
    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorMessage: { default: '' },
    helperText: { default: '' },
    size: { default: 'md' }
  },
  emits: ['update:modelValue', 'clear'],
  setup(__props: any, { emit }) {

const props = __props;





const internalValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const hasError = computed(() => props.error || !!props.errorMessage);

const clear = () => {
  emit('update:modelValue', '');
  emit('clear');
};

const classes = computed(() => ({
  'ds-textfield--sm': props.size === 'sm',
  'ds-textfield--lg': props.size === 'lg',
}));

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, _mergeProps({
    modelValue: internalValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
    label: _ctx.label,
    placeholder: _ctx.placeholder,
    outlined: _ctx.outlined,
    dense: _ctx.dense,
    disable: _ctx.disabled,
    readonly: _ctx.readonly,
    type: _ctx.type,
    error: hasError.value,
    "error-message": _ctx.errorMessage,
    hint: _ctx.helperText,
    color: _ctx.error ? 'negative' : 'primary',
    "bottom-slots": !!_ctx.helperText || !!_ctx.errorMessage,
    class: classes.value
  }, _ctx.$attrs), _createSlots({
    hint: _withCtx(() => [
      _renderSlot(_ctx.$slots, "hint", {}, () => [
        _createElementVNode("span", {
          class: _normalizeClass({ 'text-negative': hasError.value })
        }, _toDisplayString(_ctx.helperText), 3)
      ])
    ]),
    _: 2
  }, [
    (_ctx.icon)
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            _createVNode(_component_q_icon, { name: _ctx.icon }, null, 8, ["name"])
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.clearable && internalValue.value)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createVNode(_component_q_btn, {
              icon: "close",
              flat: "",
              round: "",
              dense: "",
              onClick: clear,
              "aria-label": "Clear input"
            })
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["modelValue", "label", "placeholder", "outlined", "dense", "disable", "readonly", "type", "error", "error-message", "hint", "color", "bottom-slots", "class"]))
}
}

})